export default __webpack_public_path__ + "static/media/calb.e4a1eae0.svg";